import { tones } from '../tone.constant';
import { contactTypeKeys } from './crm.contact.constant';

export const chipTones = tones;

const pipelineChipToneByName = {
    'SALES INBOUND': chipTones.blue,
    'CHURN': chipTones.red,
    'RENOVAÇÃO': chipTones.green,
    'RETRABALHO': chipTones.orange,
    'RELACIONAMENTO': chipTones.violet,
    'PACOTE SOBERANO': chipTones.purple,
}

const pipelineChipLabelByName = {
    'CHURN': 'Churn',
    'RENOVAÇÃO': 'Renovação',
}

export const getPipelineChip = (pipelineName) => {

    if (!pipelineName)
        return null;

    const normalizedName = pipelineName.trim().toUpperCase();

    return {
        label: pipelineChipLabelByName[normalizedName] || pipelineName,
        tone: pipelineChipToneByName[normalizedName] || chipTones.neutral,
    };
}

// os gatilhos guardam a cor em layout_info com a paleta inteira do Tailwind; a paleta de
// tons da tela e menor, entao as cores sem tom proprio caem na vizinha mais proxima
const toneByTailwindColor = {
    slate: chipTones.neutral,
    gray: chipTones.neutral,
    zinc: chipTones.neutral,
    neutral: chipTones.neutral,
    stone: chipTones.neutral,
    red: chipTones.red,
    rose: chipTones.red,
    pink: chipTones.red,
    orange: chipTones.orange,
    amber: chipTones.amber,
    yellow: chipTones.amber,
    lime: chipTones.green,
    green: chipTones.green,
    emerald: chipTones.emerald,
    teal: chipTones.blue,
    cyan: chipTones.blue,
    sky: chipTones.blue,
    blue: chipTones.blue,
    indigo: chipTones.violet,
    violet: chipTones.violet,
    purple: chipTones.purple,
    fuchsia: chipTones.purple,
}

export const getToneByTailwindColor = (tailwindColor) =>
    toneByTailwindColor[tailwindColor] || chipTones.neutral;

// churn é um tipo de contato de cliente: quem entrou em churn já comprou
const customerContactTypes = [contactTypeKeys.customer, contactTypeKeys.churn];

export const getContactTypeLabel = ({ contactType, customerId, leadId } = {}) => {

    if (customerContactTypes.includes(contactType) || customerId)
        return 'Cliente';

    if (contactType === contactTypeKeys.lead || leadId)
        return 'Lead';

    return null;
}
